import axios from "axios";

export const getQueriesAPI = ({page, limit, createdAt}) => {
    return axios.get(`{server}/admin/support/queries?page=${page}&limit=${limit}`).then(res => res.data.success)
}